(function () {
  'use strict';

  function escapeHtml(value) {
    var node = document.createElement('div');
    node.textContent = value || '';
    return node.innerHTML;
  }

  function reviewCard(review, locale) {
    var rating = Math.max(1, Math.min(5, Number(review.rating) || 5));
    var stars = '★'.repeat(rating) + '☆'.repeat(5 - rating);
    var initial = (review.author_name || 'G').trim().charAt(0).toUpperCase();
    var avatar = review.author_photo_url
      ? '<img class="ens-review__avatar" src="' + escapeHtml(review.author_photo_url) + '" alt="" loading="lazy" width="44" height="44">'
      : '<span class="ens-review__avatar" aria-hidden="true">' + escapeHtml(initial) + '</span>';
    var label = locale === 'fr' ? rating + ' étoiles sur 5' : rating + ' out of 5 stars';
    return '<article class="ens-review">' +
      '<div class="ens-review__top"><span class="ens-review__stars" aria-label="' + label + '">' + stars + '</span><span class="ens-review__source" aria-label="Google">G</span></div>' +
      '<p class="ens-review__text">“' + escapeHtml(review.text) + '”</p>' +
      '<div class="ens-review__author">' + avatar + '<div><p class="ens-review__name">' + escapeHtml(review.author_name) + '</p><p class="ens-review__date">' + escapeHtml(review.relative_time) + '</p></div></div>' +
      '</article>';
  }

  function init(root) {
    if (root.dataset.reviewsReady === 'true') return;
    root.dataset.reviewsReady = 'true';
    var endpoint = root.dataset.endpoint;
    var locale = (root.dataset.locale || 'en').slice(0, 2);
    var track = root.querySelector('[data-review-track]');
    var viewport = root.querySelector('[data-review-viewport]');
    var status = root.querySelector('[data-review-status]');
    var score = root.querySelector('[data-review-score]');
    var count = root.querySelector('[data-review-count]');
    var isHomepage = root.classList.contains('ens-reviews--homepage');
    var index = 0;

    function pageSize() {
      return window.innerWidth <= 900 ? 2 : 3;
    }

    function move(direction) {
      var cards = track.querySelectorAll('.ens-review:not(.ens-review--loading)');
      if (!cards.length) return;
      if (window.innerWidth <= 640) {
        if (isHomepage) {
          viewport.scrollLeft += direction * viewport.clientWidth * 0.9;
        }
        return;
      }
      var max = Math.max(0, cards.length - pageSize());
      index = Math.max(0, Math.min(max, index + direction));
      var card = cards[0];
      var gap = parseFloat(getComputedStyle(track).gap) || 0;
      track.style.transform = 'translateX(-' + (index * (card.getBoundingClientRect().width + gap)) + 'px)';
    }

    root.querySelector('[data-review-prev]').addEventListener('click', function () { move(-1); });
    root.querySelector('[data-review-next]').addEventListener('click', function () { move(1); });
    viewport.addEventListener('keydown', function (event) {
      if (window.innerWidth <= 640 && isHomepage && (event.key === 'ArrowLeft' || event.key === 'ArrowRight')) {
        event.preventDefault();
        viewport.scrollLeft += event.key === 'ArrowRight' ? viewport.clientWidth * 0.9 : viewport.clientWidth * -0.9;
        return;
      }
      if (window.innerWidth <= 640 && (event.key === 'ArrowUp' || event.key === 'ArrowDown')) {
        event.preventDefault();
        viewport.scrollBy({ top: event.key === 'ArrowDown' ? viewport.clientHeight * 0.8 : viewport.clientHeight * -0.8, behavior: 'smooth' });
        return;
      }
      if (event.key === 'ArrowLeft') move(-1);
      if (event.key === 'ArrowRight') move(1);
    });

    fetch(endpoint, { headers: { Accept: 'application/json' }, credentials: 'omit' })
      .then(function (response) {
        if (!response.ok) throw new Error('Review feed unavailable');
        return response.json();
      })
      .then(function (data) {
        if (!data.reviews || !data.reviews.length) throw new Error('No reviews returned');
        score.textContent = Number(data.rating || 5).toFixed(1);
        count.textContent = locale === 'fr'
          ? data.review_count + ' avis de clients sur Google'
          : data.review_count + ' customer reviews on Google';
        track.innerHTML = data.reviews.map(function (review) { return reviewCard(review, locale); }).join('');
        status.textContent = '';
      })
      .catch(function () {
        root.hidden = true;
      });

    window.addEventListener('resize', function () { index = 0; track.style.transform = ''; }, { passive: true });
  }

  function boot() {
    document.querySelectorAll('[data-ens-google-reviews]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
}());
